import React, { Component } from "react"
import Hls from "hls.js"

class Player extends Component {
  state = {}

  componentDidMount() {
    if (!this.player) {
      console.log("Error: Missing video player element")
      return
    }
    const video = this.player

    if (Hls.isSupported()) {
      const hls = new Hls()
      hls.loadSource(this.props.videoURL)
      hls.attachMedia(video)
      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        video.play()
      })
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = this.props.videoURL
      video.addEventListener("loadedmetadata", function() {
        video.play()
      })
    }
  }

  render() {
    return (
      <video
        preload="none"
        className="videoCanvas"
        ref={player => (this.player = player)}
        autoplay
        loop
        controls
      />
    )
  }
}
export default Player
